module.exports = __webpack_public_path__ + "img/535x485.6cb2601c.png";